export const convertValuesToNumber = (arr, values) => {
  values.forEach((element) => {
    if (arr[element]) {
      arr[element] = Number(arr[element])
    }
  })
  return arr
}
